import { useEffect, useRef, useState } from 'react';
import { useStickyBanner } from '~/context/vdp/StickyBannerContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

function StickyBannerObserver() {
  const componentRef = useRef<HTMLDivElement>(null);
  const [hasExitedAbove, setHasExitedAbove] = useState(false);
  const { setShouldShowStickyBanner } = useStickyBanner();

  useEffect(() => {
    setShouldShowStickyBanner(hasExitedAbove);
  }, [hasExitedAbove, setShouldShowStickyBanner]);

  useEffect(() => {
    const handleScroll = () => {
      if (componentRef.current) {
        const rect = componentRef.current.getBoundingClientRect();
        // Check if the top of the component is above the viewport
        setHasExitedAbove(rect.top < 0);
      }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [componentRef]);

  return <div ref={componentRef} />;
}

export default withErrorBoundary(StickyBannerObserver);
